import { render, staticRenderFns } from "./new.vue?vue&type=template&id=3df264fe&"
import script from "./new.vue?vue&type=script&lang=js&"
export * from "./new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3df264fe')) {
      api.createRecord('3df264fe', component.options)
    } else {
      api.reload('3df264fe', component.options)
    }
    module.hot.accept("./new.vue?vue&type=template&id=3df264fe&", function () {
      api.rerender('3df264fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/secteuract/new.vue"
export default component.exports